import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Table, Input, InputNumber, Popconfirm, Form, Divider, message, Button, Popover, Modal, TreeSelect, Select, Checkbox } from 'antd';
import { CheckOutlined, CloseOutlined, PoweroffOutlined, DeleteOutlined, PhoneOutlined, EditOutlined } from '@ant-design/icons';
import { connect } from 'react-redux';
import { db, cloudFunctions } from '../../../config/Fire';
import * as Constants from '../../../constants';
import moment from 'moment';
import { getCompanies } from '../../../reducers';
import './styles.css';

const { TreeNode } = TreeSelect;

const EditableContext = React.createContext();

const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  const inputNode = inputType === 'number' ? <InputNumber style={{ width: "100%" }} formatter={value => `$ ${value}`} parser={value => value.replace(/\$/g, '')} precision={2} /> : <Input maxLength={30} />;
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{ margin: 0 }}
          rules={[{ required: true, message: `Por favor, ingrese: ${title}!` }]}>
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

const EditableTableUsers = (props) => {
  const [form] = Form.useForm();
  const [data, setData] = useState(props.data);
  const [editingKey, setEditingKey] = useState('');
  const [isSaving, setIsSaving] = useState('');
  const [userModalVisible, setUserModalVisible] = useState(false)
  const [userModalLoading, setUserModalLoading] = useState(false)
  const [userModal, setUserModal] = useState(null)
  const [categoriesAssigned, setCategoriesAssigned] = useState(undefined)

	const [editModalVisible, setEditModalVisible] = useState(false)
	const [editingRecord, setEditingRecord] = useState(null)
	const [editForm] = Form.useForm()
	const [editIsSadeEmployee, setEditIsSadeEmployee] = useState(false)
	const [contractors, setContractors] = useState([])

	const { companies } = props

	useEffect(() => {
		setData(props.data)
	}, [props.data])

	useEffect(() => {
		db.ref('contractors').once('value').then(snapshot => {
			if (snapshot.exists()) {
				setContractors(snapshot.val() || [])
			}
		}).catch(console.error)
	}, [])

  // Props para controlar la visualización de columnas
  const hideUserTypeFilter = props.hideUserTypeFilter || false
  const hidePhoneIcon = props.hidePhoneIcon || false
  const hideUserTypeColumn = props.hideUserTypeColumn || false
  const showDniColumn = props.showDniColumn || false

  const columns = [
    {
      title: 'Nombre',
      dataIndex: 'name',
      width: 180,
      align: 'center',
      editable: false,
      sorter: (a, b) => a.name.localeCompare(b.name),
      render: (text, record) => {
        return (
          <div>
            {record.name}
            {!hidePhoneIcon && (
              <>
                <Divider type="vertical" />
                <Popover content={
                  <div>
                    {record.phone && record.phone !== "" ? <p>Teléfono: {record.phone}</p> : <p>No hay teléfono registrado</p>}
                  </div>
                }>
                  <PhoneOutlined />
                </Popover>
              </>
            )}
          </div>
        );
      },
    },
    {
      title: 'Correo Electrónico',
      dataIndex: 'email',
      width: 220,
      align: 'center',
      editable: false,
      sorter: (a, b) => a.email.localeCompare(b.email),
    },
    // Columna DNI (solo si showDniColumn es true)
    ...(showDniColumn ? [{
      title: 'DNI',
      dataIndex: 'dni',
      width: 110,
      align: 'center',
      editable: false,
      sorter: (a, b) => {
        const dniA = a.dni ? String(a.dni) : ''
        const dniB = b.dni ? String(b.dni) : ''
        return dniA.localeCompare(dniB)
      },
    },
    {
      title: 'Categoría',
      dataIndex: 'category',
      width: 140,
      align: 'center',
      editable: false,
      sorter: (a, b) => {
        const catA = a.category ? String(a.category) : ''
        const catB = b.category ? String(b.category) : ''
        return catA.localeCompare(catB)
      },
      render: (text, record) => {
        return text && Constants.OPERATOR_CATEGORIES[text] ? Constants.OPERATOR_CATEGORIES[text] : '--'
      }
    },
    {
      title: 'Multiples registros',
      dataIndex: 'enableMultipleRecords',
      width: 120,
      align: 'center',
      sorter: (a, b) => {
        const enableA = a.enableMultipleRecords ? String(a.enableMultipleRecords) : ''
        const enableB = b.enableMultipleRecords ? String(b.enableMultipleRecords) : ''
        return enableA.localeCompare(enableB)
      },
      render: (enable) => (enable ? 'SI' : 'NO')
    },
    {
      title: 'Teléfono de emergencia',
      dataIndex: 'emergencyPhone',
      width: 140,
      align: 'center',
      render: text => text ? text : '-'
    },
	{
		title: 'Referencia de emergencia',
		dataIndex: 'emergencyContactReference',
		width: 160,
		align: 'center',
		render: text => text ? text : '-'
	},
    {
      title: 'Domicilio Real',
      dataIndex: 'realAddress',
      width: 200,
      align: 'center',
      render: text => text ? text : '-'
    },
	{
		title: 'Pertenece a',
		dataIndex: 'isSadeEmployee',
		width: 160,
		align: 'center',
		filters: [
			{ text: 'Grupo SADE', value: 'SADE' },
			...contractors.map(name => ({ text: name, value: name }))
		],
		onFilter: (value, record) => {
			if (value === 'SADE') {
				const isSade = record.isSadeEmployee
				return isSade === true || String(isSade).toUpperCase() === 'SI' || String(isSade).toLowerCase() === 'true'
			}
			return record.contractor === value
		},
		render: (isSadeEmployee, record) => {
			if (isSadeEmployee === true || String(isSadeEmployee).toUpperCase() === 'SI' || String(isSadeEmployee).toLowerCase() === 'true') return 'Grupo SADE'
			if (record.contractor) return record.contractor
			return '-'
		}
	}] : []),
    // Columna Tipo de usuario (solo si hideUserTypeColumn es false)
    ...(!hideUserTypeColumn ? [{
      title: 'Tipo de usuario',
      dataIndex: 'userType',
      width: 180,
      align: 'center',
      editable: false,
      ...(hideUserTypeFilter ? {} : {
        filters: [
          {
            text: 'Empleado',
            value: 'Empleado',
          },
          {
            text: 'Cliente',
            value: 'Cliente',
          },
        ],
        onFilter: (value, record) => record.userType === value,
      }),
      render: (text, record) => {
        return (record.userType === Constants.userTypesMap["EMPLOYEE"]) ? (
          <div>
            {record.userType} <span className="linkCont" onClick={() => showEmployee(record)}>VER</span>
          </div>
        ) : (
          <div>
            {record.userType}
          </div>
        );
      },
    }] : []),
    {
      title: 'Registro',
      dataIndex: 'createDate',
      width: 140,
      align: 'center',
      editable: false,
      render: (value, row, index) => {
        return moment(value, "DD/MM/YYYY HH:mm").format("HH:mm DD/MM/YYYY");
      }
    },
    {
      title: 'Operación',
      dataIndex: 'operation',
      width: 180,
      align: 'center',
      render: (text, record) => {
        const editable = isEditing(record);
        return editable ? (
          <span style={{ display: 'inline-flex', alignItems: 'center', flexWrap: 'nowrap' }}>
            <EditableContext.Consumer>
              {form => (
                <Popconfirm title="¿Guardar los cambios?" onConfirm={() => save(record.id)}>
                  <Button><CheckOutlined style={{ color: 'green' }} /></Button>
                </Popconfirm>
              )}
            </EditableContext.Consumer>
            <Divider type="vertical" />
            <Popconfirm title="No se guardarán los cambios, ¿Cancelar?" onConfirm={() => cancel(record.id)}>
              <Button><CloseOutlined style={{ color: 'red' }} /></Button>
            </Popconfirm>
          </span>
        ) : (
          <span style={{ display: 'inline-flex', alignItems: 'center', flexWrap: 'nowrap' }}>
            {
              /*editingKey !== '' || isSaving ?
                <Button disabled><EditOutlined /></Button>
                :
                <Button onClick={() => edit(record)}><EditOutlined style={{ color: 'blue' }}/></Button>*/
            }
            {
              props.showEditButton && (
                <>
                  <Button onClick={() => openEditModal(record)}><EditOutlined style={{ color: 'blue' }} /></Button>
                  <Divider type="vertical" />
                </>
              )
            }
            {/*<Divider type="vertical"/>*/}
            {
              record.enabled ?
                editingKey !== '' || isSaving ?
                  <Button disabled><PoweroffOutlined /></Button>
                  :
                  <Popconfirm title="¿Deshabilitar usuario?" onConfirm={() => disable(record.id)}>
                    <Button><PoweroffOutlined style={{ color: 'green' }} /></Button>
                  </Popconfirm>
                :
                editingKey !== '' || isSaving ?
                  <Button disabled><PoweroffOutlined /></Button>
                  :
                  <Popconfirm title="¿Habilitar usuario?" onConfirm={() => enable(record.id)}>
                    <Button><PoweroffOutlined style={{ color: 'red' }} /></Button>
                  </Popconfirm>
            }

            <Divider type="vertical" />
            {
              editingKey !== '' || isSaving ?
                <Button disabled><DeleteOutlined /></Button>
                :
                <Popconfirm placement="topRight" title={<span style={{ minWidth: 180, display: 'inline-block' }}>¿Eliminar usuario?</span>} onConfirm={() => remove(record.id)}>
                  <Button><DeleteOutlined style={{ color: 'red' }} /></Button>
                </Popconfirm>
            }
          </span>
        );
      },
    },
  ]

  const showEmployee = (user) => {
    const userEmployeeCategories = []
    if (user.employeeCategories) {
      Object.keys(user.employeeCategories).forEach(employeeCategory => {
        var category = employeeCategory.replace(/_/g, "/");
        userEmployeeCategories.push(category)
      });
    }
    setUserModal(user)
    setUserModalVisible(true)
    setCategoriesAssigned(userEmployeeCategories)
  }

  const isEditing = record => record.id === editingKey;

  const cancel = () => {
    setEditingKey('')
    setIsSaving(false)
  };

  const save = async id => {
    try {
      const row = await form.validateFields();
      setIsSaving(true)
      db.ref(`${Constants.MAIN_NODES.USERS}/${id}`).update({ name: row.name })
        .then(() => {
          message.success('¡El usuario se modificó exitósamente!');
          setEditingKey('')
          setIsSaving(false)
        })
        .catch((err) => {
          message.error('Se produjo un error. Por favor, vuelva a intentarlo');
          console.log("Save user error: " + err);
          setIsSaving(false)
        });
    } catch (errInfo) {
      console.log('Validate Failed:', errInfo);
    }
  }

  const edit = record => {
    form.setFieldsValue({ ...record });
    setEditingKey(record.id)
  }

  const remove = id => {
    setIsSaving(true)
    return cloudFunctions.deleteUser({ id: id })
      .then(response => {
        setIsSaving(false)
        if (response && response.data && response.data.code !== undefined && response.data.code === 0) {
          message.success('¡El usuario se borró exitósamente!');
          form.resetFields();
        } else {
          console.log("ERROR: " + JSON.stringify(response))
          message.error("Se produjo un error. Vuelva a intentarlo más tarde.");
        }
      }).catch(error => {
        console.log("ERROR: " + JSON.stringify(error))
        message.error('Se produjo un error. Por favor, vuelva a intentarlo');
        setIsSaving(false)
      })
  }

  const disable = id => {
    setIsSaving(true)
    db.ref(`${Constants.MAIN_NODES.USERS}/${id}`).update({ enabled: false })
      .then(() => {
        message.success('¡El usuario se deshabilitó exitósamente!');
        setIsSaving(false)
      })
      .catch((err) => {
        message.error('Se produjo un error. Por favor, vuelva a intentarlo');
        console.log("Save user error: " + err);
        setIsSaving(false)
      });
  }

  const enable = id => {
    setIsSaving(true)
    db.ref(`${Constants.MAIN_NODES.USERS}/${id}`).update({ enabled: true })
      .then(() => {
        message.success('¡El usuario se habilitó exitósamente!');
        setIsSaving(false)
      })
      .catch((err) => {
        message.error('Se produjo un error. Por favor, vuelva a intentarlo');
        console.log("Save user error: " + err);
        setIsSaving(false)
      });
  }

  const handleOkModal = () => {
    if (categoriesAssigned) {
      var employeeCategories = {}
      var companiesIds = {}
      categoriesAssigned.forEach(categoryAssigned => {
        var pathSplit = categoryAssigned.split('/');
        companiesIds[pathSplit[0]] = true
        var res = categoryAssigned.replace(/\//g, "_");
        employeeCategories[res] = true
      });
      db.ref(`${Constants.MAIN_NODES.USERS}/${userModal.id}`).update({ employeeCategories, companiesIds })
        .then(() => {
          message.success('¡El usuario se modificó exitósamente!');
          setUserModal(null)
          setUserModalVisible(false)
          setUserModalLoading(false)
        })
        .catch((err) => {
          message.error('Se produjo un error. Por favor, vuelva a intentarlo');
          console.log("Update user error: " + err);
        });
    }
  }

  const handleCancelModal = () => {
    setUserModal(null)
    setUserModalVisible(false)
    setUserModalLoading(false)
  }

  const onCategoriesChanged = value => {
    setCategoriesAssigned(value)
  }

  const formatEmployeeCategories = user => {
    var userEmployeeCategories = []
    if (user.employeeCategories) {
      Object.keys(user.employeeCategories).forEach(employeeCategory => {
        var category = employeeCategory.replace(/_/g, "/");
        userEmployeeCategories.push(category)
      });
    }
    return userEmployeeCategories
  }

	const openEditModal = (record) => {
		setEditingRecord(record)
		editForm.setFieldsValue(record)
		setEditIsSadeEmployee(record.isSadeEmployee || false)
		setEditModalVisible(true)
	}

  const handleEditModalCancel = () => {
    setEditModalVisible(false)
    setEditingRecord(null)
    editForm.resetFields()
  }

  const handleEditModalOk = async () => {
    try {
      const values = await editForm.validateFields();
      setIsSaving(true);

      const updates = {
        name: values.name,
      };

      if (!hidePhoneIcon) {
        updates.phone = values.phone;
      }

      if (showDniColumn) {
        const numericDni = parseInt(values.dni, 10);

        // Validar DNI duplicado localmente
        const dniExists = data.some(user => {
          const userDni = user.dni ? parseInt(user.dni, 10) : null;
          return userDni === numericDni && user.id !== editingRecord.id;
        });

        if (dniExists) {
          message.error("El DNI ya está en uso.");
          setIsSaving(false);
          return;
        }

        updates.dni = numericDni;
        updates.category = values.category || null;
        updates.enableMultipleRecords = values.enableMultipleRecords || false;
        updates.emergencyPhone = values.emergencyPhone || null;
		updates.emergencyContactReference = values.emergencyContactReference || null
        updates.realAddress = values.realAddress || null;
		updates.isSadeEmployee = values.isSadeEmployee || false;
		updates.contractor = values.isSadeEmployee ? null : (values.contractor || null);
      }

      db.ref(`${Constants.MAIN_NODES.USERS}/${editingRecord.id}`).update(updates)
        .then(() => {
          message.success('¡El usuario se modificó exitósamente!');
          setIsSaving(false);
          setEditModalVisible(false);
          setEditingRecord(null);
          editForm.resetFields();
        })
        .catch((err) => {
          console.error(err);
          message.error('Error al actualizar usuario.');
          setIsSaving(false);
        });
    } catch (info) {
      console.log('Validate Failed:', info);
    }
  };

  const mergedColumns = columns.map(col => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: record => ({
        record,
        inputType: col.dataIndex === 'price' ? 'number' : 'text',
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });

  return (
    <EditableContext.Provider value={props.form}>
      <Table
        components={{ body: { cell: EditableCell, }, }}
        dataSource={data}
        columns={columns}
        rowKey="id"
        rowClassName="editable-row"
        scroll={{ x: 'max-content' }}
        pagination={{ onChange: cancel, }}
        onChange={(pagination, filters, sorter, extra) => {
          if (props.onTableChange) {
            props.onTableChange(extra.currentDataSource)
          }
        }}
      />
      <Modal
        key={userModal ? userModal.id : ""}
        visible={userModalVisible}
        title={`Usuario: ${userModal ? userModal.name : "-"}`}
        onOk={handleOkModal}
        onCancel={handleCancelModal}
        footer={[
          !userModal || JSON.stringify(formatEmployeeCategories(userModal)) === JSON.stringify(categoriesAssigned) ?
            <Button key="back" onClick={handleCancelModal}>Salir</Button>
            :
            <Popconfirm title="No se guardaran los cambios, ¿desea salir?" onConfirm={handleCancelModal}>
              <Button key="back">Salir</Button>
            </Popconfirm>,
          <Button key="submit" type="primary" loading={userModalLoading} onClick={handleOkModal}>
            Guardar
          </Button>,
        ]}
      >
        <p>Categorías asignadas:</p>
        <TreeSelect
          showSearch
          style={{ width: '100%' }}
          value={categoriesAssigned}
          dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
          placeholder="Categorías a las que pertenece"
          allowClear
          multiple
          treeCheckable
          onChange={onCategoriesChanged}>
          {
            companies && Object.keys(companies).map(key => {
              return (
                <TreeNode value={key} title={companies[key].name} key={key}>
                  {
                    companies[key].clientProceduresCategories &&
                    <TreeNode value={`${key}/clientProceduresCategories`} title="Categorias para clientes" key={`${key}/clientProceduresCategories`}>
                      {
                        Object.keys(companies[key].clientProceduresCategories).map(keyClientProceduresCategories => {
                          return (
                            <TreeNode value={`${key}/clientProceduresCategories/${keyClientProceduresCategories}`} title={keyClientProceduresCategories} key={`${key}/clientProceduresCategories/${keyClientProceduresCategories}`}>
                              {
                                Object.keys(companies[key].clientProceduresCategories[keyClientProceduresCategories]).map(subKeyClientProceduresCategories => {
                                  if (companies[key].clientProceduresCategories[keyClientProceduresCategories][subKeyClientProceduresCategories] !== true) {
                                    return (
                                      <TreeNode value={`${key}/clientProceduresCategories/${keyClientProceduresCategories}/${subKeyClientProceduresCategories}`} title={subKeyClientProceduresCategories} key={`${key}/clientProceduresCategories/${keyClientProceduresCategories}/${subKeyClientProceduresCategories}`}>
                                      </TreeNode>
                                    )
                                  }
                                })
                              }
                            </TreeNode>
                          )
                        })
                      }
                    </TreeNode>
                  }
                  {
                    companies[key].publicProceduresCategories &&
                    <TreeNode value={`${key}/publicProceduresCategories`} title="Categorias para publico general" key={`${key}/publicProceduresCategories`}>
                      {
                        Object.keys(companies[key].publicProceduresCategories).map(keyPublicProceduresCategories => {
                          return (
                            <TreeNode value={`${key}/publicProceduresCategories/${keyPublicProceduresCategories}`} title={keyPublicProceduresCategories} key={`${key}/publicProceduresCategories/${keyPublicProceduresCategories}`}>
                            </TreeNode>
                          )
                        })
                      }
                    </TreeNode>
                  }
                </TreeNode>
              )
            })
          }
        </TreeSelect>
      </Modal>

      <Modal
        title="Editar Usuario"
        visible={editModalVisible}
        onOk={handleEditModalOk}
        onCancel={handleEditModalCancel}
        confirmLoading={isSaving}
        okText="Guardar"
        cancelText="Cancelar"
      >
        <Form
          form={editForm}
          layout="vertical"
          name="form_in_modal"
        >
          <Form.Item
            name="name"
            label="Nombre"
            rules={[{ required: true, message: 'Por favor ingrese el nombre!' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="email"
            label="Correo Electrónico"
            rules={[
              { required: true, message: 'Por favor ingrese el correo electrónico!' },
              { type: 'email', message: 'El correo electrónico no es válido!' }
            ]}
          >
            <Input disabled />
          </Form.Item>
          {!hidePhoneIcon && (
            <Form.Item
              name="phone"
              label="Teléfono"
            >
              <Input />
            </Form.Item>
          )}
          {showDniColumn && (
            <>
              <Form.Item
                name="dni"
                label="DNI"
                normalize={value => (value || '').replace(/\D/g, '')}
                rules={[
                  { required: true, message: 'Por favor ingrese el DNI' },
                ]}
              >
                <Input maxLength={8} />
              </Form.Item>
              <Form.Item
                name="category"
                label="Categoría"
                rules={[
                  { required: true, message: 'Por favor seleccione la categoría' },
                ]}
              >
                <Select placeholder="Seleccione una categoría">
                  {
                    Constants.OPERATOR_CATEGORIES && Object.keys(Constants.OPERATOR_CATEGORIES).map(key =>
                      <Select.Option key={key} value={key}>{Constants.OPERATOR_CATEGORIES[key]}</Select.Option>
                    )
                  }
                </Select>
              </Form.Item>
              <Form.Item
                name="enableMultipleRecords"
                valuePropName="checked"
              >
                <Checkbox>Multiples registros</Checkbox>
              </Form.Item>
              <Form.Item
                name="emergencyPhone"
                label="Número de emergencia"
              >
                <Input />
              </Form.Item>
				<Form.Item
					name="emergencyContactReference"
					label="Referencia de emergencia"
				>
					<Input />
				</Form.Item>
              <Form.Item
                name="realAddress"
                label="Domicilio real"
              >
                <Input />
              </Form.Item>
				<Form.Item
					name="isSadeEmployee"
					valuePropName="checked"
				>
					<Checkbox onChange={e => setEditIsSadeEmployee(e.target.checked)}>Empleado de Grupo SADE</Checkbox>
				</Form.Item>
				<Form.Item
					name="contractor"
					label="Contratista responsable"
					rules={[{ required: !editIsSadeEmployee, message: 'Por favor seleccione un contratista' }]}
				>
					<Select
						placeholder="Seleccione un contratista"
						disabled={editIsSadeEmployee}
						allowClear
					>
						{
							contractors.map(name =>
								<Select.Option key={name} value={name}>{name}</Select.Option>
							)
						}
					</Select>
				</Form.Item>
			</>
          )}
        </Form>
      </Modal>
    </EditableContext.Provider>
  );
}

EditableTableUsers.propTypes = {
  data: PropTypes.array,
};

const mapDispatchToPropsActions = dispatch => ({
});

const mapStateToProps = state => ({
  companies: getCompanies(state),
});

export default connect(mapStateToProps, mapDispatchToPropsActions)(EditableTableUsers);
